// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=a7855f15-2a6b-4cd8-88ce-da0e506943bd";
};